import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

// Each destination once. `theme` as in AnalystBroNavbar.
export default function AnalystBroFooter({ theme = "ab-dark" }) {
  const head = "font-mono text-[11px] uppercase tracking-[0.12em] text-[var(--ab-faint)]";
  const link = "text-[var(--ab-muted)] hover:text-[var(--ab-text)] transition";
  return (
    <footer className={`${theme} border-t border-[var(--ab-border)]`} style={{ background: "var(--ab-bg-alt)" }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-8 py-14 grid grid-cols-2 md:grid-cols-[2fr_1fr_1fr_1fr] gap-10">
        <div className="col-span-2 md:col-span-1 space-y-3 max-w-sm">
          <Link to="/" className="flex items-center gap-2">
            <img src="/images/analystbro-logo.png" alt="" className="ab-logo h-7 w-7" />
            <span className="font-display font-bold text-lg">AnalystBro</span>
          </Link>
          <p className="text-sm text-[var(--ab-muted)] leading-relaxed">
            AI equity research: a desktop agent on your own AI plan, and an MCP server for Claude, ChatGPT and Gemini.
          </p>
        </div>
        <div className="space-y-3 text-sm flex flex-col">
          <span className={head}>Product</span>
          <Link to="/agentbro" className={link}>AnalystBro Agent</Link>
          <a href="/#download" className={link}>Desktop app</a>
          <Link to="/backtesting" className={link}>Backtesting</Link>
          <Link to="/ai-apps" className={link}>MCP server for AI apps</Link>
          <a href="/#enterprise" className={link}>Enterprise</a>
        </div>
        <div className="space-y-3 text-sm flex flex-col">
          <span className={head}>Data</span>
          <Link to="/markets/bd" className={link}>Bangladesh market data</Link>
          <Link to="/markets/DSE" className={link}>DSE market today</Link>
          <Link to="/markets/bd/funds/open-end" className={link}>Bangladesh mutual funds</Link>
          <a href="https://www.sec.gov/edgar" target="_blank" rel="noreferrer" className={`${link} inline-flex items-center gap-1`}>
            SEC EDGAR Filings <ArrowUpRight size={13} />
          </a>
          <a href="https://www.ssga.com" target="_blank" rel="noreferrer" className={`${link} inline-flex items-center gap-1`}>
            State Street SPDR ETFs <ArrowUpRight size={13} />
          </a>
        </div>
        <div className="space-y-3 text-sm flex flex-col">
          <span className={head}>Company</span>
          <a href="/research" className={link}>Research</a>
          <a href="/#contact" className={link}>Contact & Feedback</a>
          <a href="/privacy.html" className={link}>Privacy</a>
          <a href="/terms.html" className={link}>Terms</a>
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-4 sm:px-8 pb-10 text-xs text-[var(--ab-faint)]">
        © {new Date().getFullYear()} AnalystBro. All rights reserved. For informational and research purposes only.
      </div>
    </footer>
  );
}
